// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"326":"75e07274","783":"b6c45ace"}[chunkId] + ".chunk.js";
};